
import React from 'react';
import { Route } from 'react-router-dom';
import CityIndustryLanding from './CityIndustryLanding';
import { cityIndustryMap } from '@/data/cityIndustryData';

// This function generates all the routes for city-industry combinations
export const generateCityIndustryRoutes = () => {
  return Object.entries(cityIndustryMap).flatMap(([citySlug, industryList]) => 
    industryList.map(industrySlug => {
      const path = `/web-design/${industrySlug}/${citySlug}`;
      
      return (
        <Route 
          key={path} 
          path={path} 
          element={<CityIndustryLanding industrySlug={industrySlug} citySlug={citySlug} />} 
        />
      );
    })
  );
};

// Generate a list of all URLs for the sitemap
export const getAllCityIndustryUrls = (): string[] => {
  return Object.entries(cityIndustryMap).flatMap(([citySlug, industryList]) => 
    industryList.map(industrySlug => `/web-design/${industrySlug}/${citySlug}`)
  );
};

// Keep the component for backwards compatibility, but use React.Fragment
const CityIndustryRouteHandler: React.FC = () => {
  return <>{generateCityIndustryRoutes()}</>;
};

export default CityIndustryRouteHandler;
